module.exports = {
	"tip": "findify-components-autocomplete--tip__tip",
	"highlight": "findify-components-autocomplete--tip__highlight"
};